<template>
    <div class="container">
        <div style="margin-bottom: 20px">
            <div>支付方式 : {{ open_third_pay.alias }}</div>
        </div>

        <div style="font-weight: 700; margin-bottom: 30px; color: #606266">收费抽成模式</div>
        <div class="modeStyle_big">
            <div class="mode_style one" v-if="open_third_pay.val != 2">
                <div class="modeTitle">模式一</div>
                <div class="mode_body">
                    <div class="modeHead">
                        原有收费模式全职司机每单不收费、兼职司机每单收取固定费用，钱收入到各个子公司及加盟商，支付方式为微信、支付宝和银行卡。不可自动提现
                        不扣服务费
                    </div>
                    <div class="mode_content">
                        <div>配置每笔订单抽成金额（不配置默认为0）</div>
                        <div>全职司机:不抽成</div>
                        <div>
                            兼职司机:<el-input disabled
                                v-model="driver_insurance"
                                class="input-item1 input-item-active"
            
                            >
                            </el-input> 元
                        </div>
                        <div>原配置微调中的{保险金}，从司机保险金账户扣除</div>
                        <!-- <el-button @click="use_mode_change(1,submit_data.use_mode)" :type="btn_color" class="use_mode" v-if="submit_data.use_mode == 1">使用中</el-button>
                        <el-button @click="use_mode_change(1,submit_data.use_mode)" :type="btn_color" class="use_mode" v-else>空闲中</el-button> -->
                        <el-button
                            @click="use_mode_change(1, submit_data.use_mode)"
                            :type="submit_data.use_mode == 1 ? 'success' : 'info'"
                            class="use_mode"
                            >{{ submit_data.use_mode == 1 ? '使用中' : '空闲中' }}</el-button
                        >
                    </div>
                </div>
            </div>
            <div class="mode_style two" v-if="open_third_pay.val != 2">
                <div class="modeTitle">模式二</div>
                <div class="mode_body">
                    <div class="modeHead">按照订单总金额进行百分比抽成 扣取司机余额，不可自动提现,不扣服务费</div>
                    <div class="mode_content">
                        <div>配置每笔订单抽成金额（不配置默认为0）</div>
                        <div>
                            <span class="title">全职司机 : </span>

                            <el-select
                                class="input-item1"
                                @change="selectConfig($event,2.1)"
                                v-model="two_full_time_mode"
                                placeholder="请选择全职司机配置"
                                clearable
                            >
                                <el-option v-for="item in two_full_driver" :key="item.val" :label="item.alias" :value="item.val">
                                </el-option>
                            </el-select>
                            <div>
                                <el-input
                                    v-model="submit_data.two_withdrawal_amount"
                                    class="input-item1 input-item-active"
                                    style=""
                                    :placeholder="submit_rules.two_withdrawal_amount.placeholder"
                                >
                                </el-input>
                                {{submit_data.two_full_time_mode == '0' ? '%' : '元' }}
                            </div>
                        </div>
                        <div>
                            <span class="title">兼职司机 : </span>

                            <el-select @change="selectConfig($event,2.2)" class="input-item1" v-model="two_part_time_mode" placeholder="请选择兼职司机配置" clearable>
                                <el-option v-for="item in two_jz_driver" :key="item.val" :label="item.alias" :value="item.val"> </el-option>
                            </el-select>
                            <div>
                                <el-input
                                    v-model="submit_data.two_part_time_amount"
                                    class="input-item1 input-item-active"
                                    :placeholder="submit_rules.two_part_time_amount.placeholder"
                                >
                                </el-input>
                                {{submit_data.two_part_time_mode == '0' ? '%' : '元' }}
                            </div>
                        </div>

                        <el-button
                            @click="use_mode_change(2, submit_data.use_mode)"
                            :type="submit_data.use_mode == 2 ? 'success' : 'info'"
                            class="use_mode"
                            >{{ submit_data.use_mode == 2 ? '使用中' : '空闲中' }}</el-button
                        >
                    </div>
                </div>
            </div>
            <div class="mode_style" v-if="open_third_pay.val == 2">
                <div class="modeTitle">模式三</div>
                <div class="mode_body">
                    <div class="modeHead">
                        <p>实行聚合支付，司机可自动提现，配置的扣款关联到司机余额</p>
                        <p>1、线上支付-采取聚合支付，t+1的形式清分到各子公司及加盟商公户</p>
                        <p>2、司机余额由各个子公司及加盟商单独负责收入</p>
                        <p>3、软件平台会收取，司机/子公司&加盟商，平台服务费1.8元/单</p>
                    </div>
                    <div class="mode_content">
                        <div>配置每笔订单抽成金额（不配置默认为0）</div>
                        <div>
                            <span class="title">全职司机 : </span>

                            <el-select
                                class="input-item1"
                                @change="selectConfig($event,3.1)"
                                v-model="three_full_time_mode"
                                placeholder="请选择全职司机配置"
                                clearable
                            >
                                <el-option v-for="item in three_full_driver" :key="item.val" :label="item.alias" :value="item.val">
                                </el-option>
                            </el-select>
                            <div>
                                <el-input
                                    v-model="submit_data.three_withdrawal_amount"
                                    class="input-item1 input-item-active"
                                    style=""
                                    :placeholder="submit_rules.three_withdrawal_amount.placeholder"
                                >
                                </el-input>
                                {{submit_data.three_full_time_mode == '0' ? '%' : '元' }}
                            </div>
                        </div>
                        <div>
                            <span class="title">兼职司机 : </span>

                            <el-select @change="selectConfig($event,3.2)" class="input-item1" v-model="three_part_time_mode" placeholder="请选择兼职司机配置" clearable>
                                <el-option v-for="item in three_jz_driver" :key="item.val" :label="item.alias" :value="item.val">
                                </el-option>
                            </el-select>
                            <div>
                                <el-input
                                    v-model="submit_data.three_part_time_amount"
                                    class="input-item1 input-item-active"
                                    :placeholder="submit_rules.three_part_time_amount.placeholder"
                                >
                                </el-input>
                                {{submit_data.three_part_time_mode == '0' ? '%' : '元' }}
                            </div>
                        </div>

                        <el-button
                            @click="use_mode_change(3, submit_data.use_mode)"
                            :type="submit_data.use_mode == 3 ? 'success' : 'info'"
                            class="use_mode"
                            >{{ submit_data.use_mode == 3 ? '使用中' : '空闲中' }}</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center; margin-top: 40px">
            <!-- <submitBtn
                @onSubmitDig="onSubmitDig"
                :data="submit_data"
                :rules="submit_rules"
                :url="submit_url"
                :JSON_Boolean="true"
                @toJSON="toJson"
            ></submitBtn> -->

            <el-button @click="onSubmitDig" type="success">保存</el-button>
        </div>
    </div>
</template>

<script>
var _this;
export default {
    components: {},
    data() {
        return {
            // 记录use_mode 接口初始值
            // use_mode_base: '',
            driver_insurance: '',
            two_full_time_mode: '',
            three_full_time_mode: '',
            two_part_time_mode: '',
            three_full_time_mode: '',
            three_part_time_mode: '',
            submit_url: '/paymode/editpayModeSub',
            open_third_pay: {
                val: '',
                alias: ''
            },

            // 模式二全职司机
            two_full_driver: [],
            // 模式二兼职司机
            two_jz_driver: [],
            // 模式三全职司机
            three_full_driver: [],
            // 模式三兼职司机
            three_jz_driver: [],

            // 表单数据
            submit_data: {
                use_mode: '',

                // 模式二 0订单金额百分比 1固定金额
                two_full_time_mode: '',

                // 模式二抽成金额
                two_withdrawal_amount: '',

                // 模式二 兼职司机 0 订单金额百分比
                two_part_time_mode: '',

                // 模式二订单金额百分比 单位%
                two_part_time_amount: '',

                // 模式三订 0订单金额百分比 1固定金额
                three_full_time_mode: '',

                // 模式三抽成金额
                three_withdrawal_amount: '',

                // 模式三 兼职司机 0 订单金额百分比
                three_part_time_mode: '',

                // 模式三订单金额百分比 单位%
                three_part_time_amount: ''
            },

            submit_rules: {
                two_full_time_mode: {
                    placeholder: '模式二全职司机订单抽成',
                    rules: {
                        required: true,
                        message: '模式二全职司机订单抽成',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                two_withdrawal_amount: {
                    placeholder: '模式二全职司机抽成金额或百分比',
                    rules: {
                        required: true,
                        message: '模式二全职司机抽成金额或百分比为不小于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                two_part_time_mode: {
                    placeholder: '模式二兼职司机订单抽成',
                    rules: {
                        required: true,
                        message: '模式二兼职司机订单抽成',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                two_part_time_amount: {
                    placeholder: '模式二兼职司机抽成金额或百分比',
                    rules: {
                        required: false,
                        message: '模式二兼职司机抽成金额或百分比',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                three_full_time_mode: {
                    placeholder: '模式三全职司机订单抽成',
                    rules: {
                        required: true,
                        message: '模式三全职司机订单抽成为1-50的数字',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                three_withdrawal_amount: {
                    placeholder: '模式三全职司机抽成金额或百分比',
                    rules: {
                        required: false,
                        message: '模式三全职司机抽成金额或百分比',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                three_part_time_mode: {
                    placeholder: '模式三兼职司机订单抽成',
                    rules: {
                        required: false,
                        message: '模式三兼职司机订单抽成',
                        regulation: 'gt_str',
                        rulesData: '0'
                    }
                },
                three_part_time_amount: {
                    placeholder: '模式三兼职司机抽成金额或百分比',
                    rules: {
                        required: false,
                        message: '模式三兼职司机抽成金额或百分比',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.payModeList();
    },

    methods: {
        // 使用中，空闲中按钮切换，e的值传1为模式一，2为模式二，3为模式三，如果use_mode的值为1也就是等于参数e 则模式1为使用中，以此类推。
        use_mode_change(e, use_mode) {
            if (e == use_mode) {
                _this.submit_data.use_mode = '';
                _this.$message('请点击确认按钮保存当前修改模式');
            } else {
                _this.submit_data.use_mode = e;
                _this.$message('请点击确认按钮保存当前修改模式');
            }

            
        },

        /*模式二和模式三的全职司机和兼职司机都调用同样的方法，所以公用统一方法，传不同的参数，
        2.1表示模式二的全职司机，2.2表示模式2的兼职司机,切换选项的时候清空输入框数据*/
        selectConfig(val,mode_change) {
            console.log(val);
            if(mode_change==2.1){
                _this.submit_data.two_withdrawal_amount = '';
                _this.submit_data.two_full_time_mode = val;
                // _this.two_full_time_mode = _this.submit_data.two_full_time_mode == 0?'订单金额百分比':'固定金额';
                console.log(_this.two_full_time_mode);
                
            }else if(mode_change==2.2){
                _this.submit_data.two_part_time_mode = val;

                _this.submit_data.two_part_time_amount = '';
            }else if(mode_change==3.1){
                _this.submit_data.three_full_time_mode = val;
                _this.submit_data.three_withdrawal_amount = '';
            }else {
                _this.submit_data.three_part_time_mode = val;

                _this.submit_data.three_part_time_amount = '';
            }
            
        },

        // 搜索列表
        payModeList() {
            _this
                .$post('/paymode/payModeList')
                .then((res) => {
                    // 支付方式回显为汉字
                    _this.open_third_pay.alias = res.data.open_third_pay.alias;

                    // 根据支付方式的值判断显示模式几
                    _this.open_third_pay.val = res.data.open_third_pay.val;

                    // 模式一兼职司机输入框取值
                    _this.driver_insurance = res.data.driver_insurance;

                    // 模式二全职司机下拉选 显示为汉字
                    _this.two_full_time_mode = res.data.two_full_time_mode.alias;

                    // 模式三全职司机下拉选 显示为汉字
                    _this.three_full_time_mode = res.data.three_full_time_mode.alias;
                    
                    // 模式二全职司机下拉选提交数据绑定值
                    _this.submit_data.two_full_time_mode = res.data.two_full_time_mode.val;

                    // 模式三全职司机下拉选提交数据绑定值
                    _this.submit_data.three_full_time_mode = res.data.three_full_time_mode.val;

                    // 模式二全职司机输入框取值
                    _this.submit_data.two_withdrawal_amount = res.data.two_withdrawal_amount;

                    // 模式三全职司机输入框取值
                    _this.submit_data.three_withdrawal_amount = res.data.three_withdrawal_amount;

                    // 模式二 兼职司机 下拉选显示为汉字
                    _this.two_part_time_mode = res.data.two_part_time_mode.alias;

                    // 模式三 兼职司机 下拉选显示为汉字
                    _this.three_part_time_mode = res.data.three_part_time_mode.alias;

                    // 模式二兼职司机 下拉选提交数据绑定值
                    _this.submit_data.two_part_time_mode = res.data.two_part_time_mode.val;

                    // 模式三兼职司机 下拉选提交数据绑定值
                    _this.submit_data.three_part_time_mode = res.data.three_part_time_mode.val;

                    // 模式二兼职司机输入框提交数据绑定值
                    _this.submit_data.two_part_time_amount = res.data.two_part_time_amount;

                    // 模式三兼职司机输入框提交数据绑定值
                    _this.submit_data.three_part_time_amount = res.data.three_part_time_amount;  
                    
                    // 模式二全职司机下拉选循环数组
                    _this.two_full_driver = res.data.two_full_time_mode.select_array;
                    // 模式二兼职司机下拉选循环数组
                    _this.two_jz_driver = res.data.two_part_time_mode.select_array;
                    // 模式三全职司机下拉选循环数组
                    _this.three_full_driver = res.data.three_full_time_mode.select_array;
                    _this.three_jz_driver = res.data.three_part_time_mode.select_array;

                    // 使用中或者空闲中
                    _this.submit_data.use_mode = res.data.use_mode;
                    
                })
                .catch((err) => {});
        },
        // 提交

        onSubmitDig() {
            if (_this.submit_data.use_mode == '') {
                _this.$message.error('收费抽成模式未选择');
                return;
            }

            _this
                .$post(_this.submit_url, _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success('保存成功');
                    _this.payModeList();
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.one {
    margin-right: 10px;
}
.two {
    margin-left: 10px;
}
.container {
    height: 100%;
    box-sizing: border-box;
}
.input-item1 {
    max-width: 190px!important;
    width: 60%!important;
    box-sizing: content-box!important;
}

.input-item-active {
    padding-left: 58px;
    margin-top: 10px;
}
.mode_content {
    box-sizing: border-box;
    padding: 20px 30px 0;
}
.mode_content > div {
    margin-top: 20px;
}
.mode_body {
    border: 1px solid #e0e0e0;
    padding-bottom: 20px;
    min-height: 500px;
    box-sizing: border-box;
    position: relative;
}

.use_mode {
    text-align: center;
    display: block;

    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
}
.mode_style {
    width: 25%;
}
.modeStyle_big {
    display: flex;
    justify-content: center;
    color: #606266;
}

.modeTitle {
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
}
.modeHead {
    border-bottom: 1px solid #e0e0e0;
    padding: 10px;
    text-align: center;
    color: #606266;
    line-height: 25px;
}
.title{
    color: #606266!important;
}
</style>





